import {createContext} from "react";

export const  ResizeContext = createContext({})